import {deleteServiceAuthorized, getService, getServiceAuthorized,postServiceAuthorizedMultipartForm, postService, postServiceAuthorized, postServiceFormData, postServiceFormDataAuthorized, putServiceAuthorized,allservicess,} from '../configs/FetchRequest';
import { route } from '../constants/routePath';
import AxiosRequest from '../configs/api';

const OtherService = {};
OtherService.egvList = () => AxiosRequest.get(
  `/${route.pointRedemption}/api/v2/egvList`
);
// all estimate
OtherService.estimateTypeList = () => AxiosRequest.get(
  `/${route.leads}/api/v1/estimator/type-list`,
);
OtherService.estimateActivityList = () => AxiosRequest.get(
  `/${route.leads}/api/v1/estimator/group-members-list`,
);
OtherService.estimateProductList = (payload) => AxiosRequest.post(
  `/${route.leads}/api/v1/estimator/product-list`,
  payload
);
OtherService.estimateTotal = (payload) => AxiosRequest.post(
  `/${route.leads}/api/v1/estimator/product-estimation-list`,
  payload
);
OtherService.estimateSave = (payload) => AxiosRequest.post(
  `/${route.leads}/api/v1/estimator/save-estimation-prices`,
  payload
);
OtherService.estimateList = () => AxiosRequest.get(
  `/${route.leads}/api/v1/estimator/saved-estimation-list`,
);
OtherService.estimateApprove = (payload) => AxiosRequest.post(
  `/${route.leads}/api/v1/estimator/approve-estimation`,
  payload,
);
OtherService.estimateDelete = (payload) => AxiosRequest.put(
  `/${route.leads}/api/v1/estimator/delete-estimation`,
  payload,
);
OtherService.estimateGetImage = (id) => AxiosRequest.get(
  `/${route.leads}/api/v1/estimator/share-estimation-image?estimationId=${id}`,
);

OtherService.egvOTPSend = (id) => AxiosRequest.get(
  `/${route.pointRedemption}/api/v2/unlockEgv/${id}`,
);

OtherService.egvUnlock = (payload) => AxiosRequest.post(
  `/${route.pointRedemption}/api/v2/unlockEgv`,
  payload,
  );
OtherService.taskList = () => AxiosRequest.get(
  `/${route.productCatalog}/catalognodes/tasks`,
);
OtherService.myPoints = () => AxiosRequest.get(
    `/${route.pointAccrual}/api/v1/pointsNode/getAvailablePoints`,
  );
   OtherService.downloadProductPDF = () => AxiosRequest.get(
    `/${route.productCatalog}/catalognodes/download/products`,
  );

OtherService.editAddress = (payload) => AxiosRequest.post(
    `/${route.pointRedemption}/api/v1/orders/address`,
    payload
  );

OtherService.contentSpot = (query) => AxiosRequest.get(
    `/${route.productCatalog}/catalognodes/contentspots/mobileApp${query}`,
  );
OtherService.newsletter = (payload) => AxiosRequest.post(
    `/${route.productCatalog}/catalognodes/newsletters`,
    payload,
  );
  //Event Ceation
  OtherService.eventCreation = (payload) => AxiosRequest.post(
    `/${route.leads}/api/v1/event/create`,
    payload,
  );
  //Event Listing
   OtherService.eventList = () => AxiosRequest.get(
    `/${route.leads}/api/v1/event/list`,
  );
  //Event Content List
  OtherService.contentList = () => AxiosRequest.get(
    `/${route.registration}/api/v1/masterNode/all/content/list`
  )
//Event Listing by Hierchy Id
OtherService.eventListByHierarchyId = (hierarchyId) => AxiosRequest.get(
  `/${route.leads}/api/v1/event/list?hierarchyId=${hierarchyId}`,
   hierarchyId
)
//Event Details by Hierchy Id
OtherService.eventDetailsByHierarchyId = (eventId) => AxiosRequest.get(
  `/${route.leads}/api/v1/event/list/by/eventId?eventId=${eventId}`
)
OtherService.eventParticipate = (payload) => AxiosRequest.post(
  `/${route.leads}/api/v1/event/participate`,
  payload
);
  //Hierarchies List
  OtherService.hierarchiesList = () => AxiosRequest.get(
    `/${route.registration}/api/v1/masterNode/all/master/hierarchies`
  )
  //Event Edit
  OtherService.eventListById = (eventId) => AxiosRequest.get(
      `/${route.leads}/api/v1/event/list/by/eventId?eventId=${eventId}`, 
  );
 //Gallery
 OtherService.gallery = () => AxiosRequest.get(
  `/${route.productCatalog}/catalognodes/gallery/galleryMobileApp`,
 )
 //Terms
 OtherService.termsCondition = () => AxiosRequest.get(
  `/${route.productCatalog}/catalognodes/contentspots/mobileAppTermsAndCondition`,
 )
 //Faqs
 OtherService.faqContent = () => AxiosRequest.get(
  `/${route.productCatalog}/catalognodes/contentspots/mobileAppFAQ`,
 ) 
 //ProgramDetails
 OtherService.programDetails = () => AxiosRequest.get(
    `/${route.productCatalog}/catalognodes/contentspots/programDetailsMobileApp`,
 )
 //UserGuide
 OtherService.userGuideData = () => AxiosRequest.get(
  `/${route.productCatalog}/catalognodes/contentspots/userGuideWebApp`,
)
//Event Edit
OtherService.eventEdit = (payload) => AxiosRequest.post(
  `/${route.leads}/api/v1/event/edit`,
  payload,
)
//Dealer API FOR Purchase Registration Contractor
OtherService.dealerList = () => AxiosRequest.get(
  `${route.registration}/api/v1/salesNode/sale/get/all/dealers/12`,
)
//Contact Us
OtherService.contact = () => AxiosRequest.get(
  `/${route.productCatalog}/catalognodes/contact-us`,
)
//Banner Images

OtherService.bannerHome = () => AxiosRequest.get(
  `/${route.productCatalog}/catalognodes/contentspots/homeBannerWebApp`,
)
OtherService.aboutWeb = () => AxiosRequest.get(
  `/${route.productCatalog}/catalognodes/contentspots/aboutUsWeb`,
)
//Address
OtherService.allAddresses = () => AxiosRequest.get(
  `/${route.pointRedemption}/api/v1/orders/address/list`,
);
//Add Address
OtherService.addAddress = (payload) => AxiosRequest.post(
  `/${route.pointRedemption}/api/v1/orders/address/add`,
  payload,
);

OtherService.activityList = () => AxiosRequest.get(
  `/${route.pointRedemption}/api/v1/activityList?`,
);
OtherService.addressListById = (addressId) => AxiosRequest.get(
  `/${route.pointRedemption}/api/v1/orders/address/list/${addressId}`, 
);
//Menu
OtherService.menuWeb = async (language_Id,hierarchy_Id) => AxiosRequest.get(
  `/${route.registration}/api/v1/registrationProfileNode/dynamic/menu?language_Id=${language_Id}&hierarchy_Id=${hierarchy_Id}`, 
  language_Id,
  hierarchy_Id
);

//EGV
OtherService.egvList = () => AxiosRequest.get(
  `/${route.pointRedemption}/api/v2/egvList`,
  
);

//Review
OtherService.reasonListReview = () => AxiosRequest.get(
  `/${route.pointRedemption}/api/v1/orders/feedback/reasons`,
  
);
OtherService.reviewCreate = (payload) => AxiosRequest.post(
  `/${route.pointRedemption}/api/v1/orders/feedback/create`,
  payload,
  
);
//Upload File
OtherService.uploadFile  = (payload) => AxiosRequest.post(
  `/${route.registration}/api/v1/profileNode/create/user/libruary`,
   payload,
)
OtherService.uploadFileList  = () => AxiosRequest.get(
  `/${route.registration}/api/v1/profileNode/get/user/libruary?`,
)
// Service Registration
OtherService.serviceProductList = () => AxiosRequest.get(
  `/${route.pointAccrual}/api/v1/salesNode/service/get/product`,
);
OtherService.saveServiceRegistration = (payload, token) => AxiosRequest.post(
  `/${route.pointAccrual}/api/v2/salesNode/service/register`,
  payload,
  token,
);
OtherService.dealerServiceRegistration = (payload) => AxiosRequest.post(
  `/${route.pointAccrual}/api/v2/salesNode/dealer/service/register`,
  payload,
);
// OtherService.dealerServiceRegistration = (token, payload) => AxiosRequest.post(
//   `/${route.pointAccrual}/api/v2/salesNode/dealer/service/registration`,
//   payload,
//    { Authorization: `Bearer ${token}` },
// );
// OtherService.getServiceList = () => AxiosRequest.get(
//   `/${route.pointAccrual}/api/v1/salesNode/get/service/AllInfo`,
// );
OtherService.getServiceList = (limit, pageNo, currentTab) => AxiosRequest.get(
    `/${
      route.pointAccrual
    }/api/v2/salesNode/get/service/All/Info/Data?is_verified=${currentTab}&limit=${limit}&offset=${
      (pageNo - 1) * limit
    }`,
  );
OtherService.getServiceReasonList = (reason,hier_id) => AxiosRequest.get(
  `/${route.pointAccrual}/api/v1/salesNode/service/reasons/${reason}/${hier_id}`,
);
OtherService.serviceAcceptOrReject = (payload) => AxiosRequest.post(
  `/${route.pointAccrual}/api/v2/salesNode/service/accept/or/rejectNew`,
  payload,
);
//Service Registration
OtherService.campaignList = () => AxiosRequest.get(
  `/${route.pointRedemption}/api/v1/campaignList`,
);
OtherService.campaignDetails = (id) => AxiosRequest.get(
  `/${route.pointRedemption}/api/v1/campaignDetails/${id}`,
);
OtherService.activityList = () => AxiosRequest.get(
  `/${route.pointRedemption}/api/v1/activityList`,
);
OtherService.nearbyDealerList = (lat,long) => AxiosRequest.get(
  // `/${route.registration}/api/v1/profileNode/get/dealer/locator?geo_lat=${lat}&geo_long=${long}`,
  `/${route.registration}/api/v1/profileNode/get/locations/byradious?geo_lat=${lat}&geo_long=${long}`,
);

OtherService.myPointsNew = () =>
AxiosRequest.get(
  `/${route.pointAccrual}/api/v2/pointsNode/getPoints?date_from=&date_to=`,
);

OtherService.getunApprovedDocuments = () =>
AxiosRequest.get(
  `/${route.registration}/api/v3/registrationProfileNode/unApprovedDocuments?`,
);

OtherService.getTierPerfomance = () =>
  AxiosRequest.post(
    `/${route.pointAccrual}/api/v1/salesNode/sales/export/monthly?`,
    {},
  );

  OtherService.getMemberPerformance = (query, status) =>
  AxiosRequest.get(
    `/${route.registration}/api/v1/profileNode/get/my/member/perfomance?query_text=${query}&status=${status}`
  );

  OtherService.getRedemptionCatalogue = (payload, token) =>
    AxiosRequest.post(
      `/${route.registration}/api/v3/masterNode/redemptionCatalogue`,
      payload,
      token,
    );
    
  OtherService.getTseContractorProductivity = (payload) =>
    AxiosRequest.post(
      `/${route.pointAccrual}/api/v2/salesNode/contractor-productivity`,
      payload,
    );

  OtherService.getTseContratorBusinessData = () =>
    AxiosRequest.post(
      `/${route.pointAccrual}/api/v2/salesNode/my-contractors/business-performance/status`,
      {},
    );

  OtherService.getTseSaleReport = (payload) =>
    AxiosRequest.post(
      `/${route.pointAccrual}/api/v2/salesNode/my-contractors/sale-report`,
      payload,
    );

  OtherService.getTseApprovalAnalytics = (payload) =>
    AxiosRequest.post(
      `/${route.pointAccrual}/api/v2/salesNode/contractor-entry-approval-status`,
      payload,
    );

  OtherService.getTseMonthlyEnrollments = (payload) =>
    AxiosRequest.post(
      `/${route.registration}/api/v3/registrationProfileNode/my/performance/total-enrollement-influencers`,
      payload,
    );

  OtherService.getSalePerformanceData = (payload) => 
    AxiosRequest.post(
      `/${route.pointAccrual}/api/v1/pointsNode/my-sale-performace`,
      payload,
    );

  OtherService.getTsePieData = () => 
    AxiosRequest.post(
      `/${route.registration}/api/v3/registrationsNode/conditional/user/count`,
      {},
    );

  OtherService.getTseEnrollmentData = (payload) => 
    AxiosRequest.post(
      `/${route.registration}/api/v4/registrationProfileNode/enrollment-target`,
      payload,
    );

  OtherService.getNextTierPerformance = () =>
    AxiosRequest.post(
      `/${route.registration}/api/v3/profileNode/my-tier/performace`,
      {},
    );

  OtherService.getDetailedPoints = () =>
    AxiosRequest.post(
      `/${route.pointAccrual}/api/v2/pointsNode/my-points/summary`,
      {},
    );

  OtherService.myPointsNew = () => 
    AxiosRequest.get(
      `/${route.pointAccrual}/api/v2/pointsNode/getPoints?date_from=&date_to=`,
      {},
    );

  OtherService.getPerformance = () => 
    AxiosRequest.post(
      `/${route.registration}/api/v3/profileNode/my-tier/current-performace`,
    {},
    );

  OtherService.getDealerLoyaltyPerformanceData = (payload) =>
    AxiosRequest.post(
      `/${route.pointAccrual}/api/v2/salesNode/dealer/performance/status`,
      payload,
    );

  OtherService.getLocation = () => 
    AxiosRequest.post(
      `/${route.registration}/api/v3/profileNode/get-user/info`,
       {},
    )

  OtherService.receivedConcent = (payload) => 
    AxiosRequest.post(
      `/${route.pointRedemption}/api/v1/orders/addConsent`,
    payload,
  );

  OtherService.concentOptionList = () =>
    AxiosRequest.get(
      `/${route.pointRedemption}/api/v1/orders/consent-status-list?`,
    );

  OtherService.addressFailedUpload = () =>
    AxiosRequest.get(
      `/${route.pointRedemption}/api/v1/orders/pending-verification/failed-upload?`,
    );

  OtherService.getPincodeDetails = (pincode) =>
    AxiosRequest.get(
      `/${route.pointRedemption}/api/v1/orders/address/state-district/${pincode}?`,
    );

  OtherService.exportDealerPointStatement = (payload) =>
    AxiosRequest.post(
      `/${route.pointAccrual}/api/v1/salesNode/dealer/point/statement/export`,
      payload,
    );

  OtherService.getSaleDataDownload = (payload) =>
    AxiosRequest.post(
      `/${route.pointAccrual}/api/v1/salesNode/dealer/sale/export`,
      payload,
    );
export default OtherService;